<template>
  <AppSidebar v-if="isAuthenticated" />
  <div
    class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent"
    v-if="isAuthenticated"
  >
    <AppHeader />
    <div class="body flex-grow-1 px-3">
      <!-- <CContainer> -->
      <router-view />
      <!-- </CContainer> -->
    </div>
    <AppFooter />
  </div>
  <AppAside v-if="isAuthenticated" />
</template>
<script>
// import { CContainer } from '@coreui/vue-pro'
import AppAside from '@/components/AppAside.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppAside,
    AppFooter,
    AppHeader,
    AppSidebar,
    // CContainer,
  },

  data() {
    return {
      isAuthenticated: false,
    }
  },

  methods: {
    isLogin() {
      const token = sessionStorage.getItem('token')
      if (!token) {
        this.$router.push('/pages/login')
      } else {
        this.isAuthenticated = true
      }
    },
  },

  async mounted() {
    await this.isLogin()
  },
}
</script>
